import { FC, useCallback } from 'react';
import { Card } from '../../../components/Card';
import { FormattedMessage, useIntl } from 'react-intl';
import { CardTitle } from '../../../components/CardTitle';
import styles from './DoorLock.module.css';
import clsx from 'clsx';
import { CommandType, changeLock, useLock } from '../../../services/locking';
import { useConfirmDialog } from '../../../components/ConfirmDialogProvider';

export const DoorLock: FC = () => {
  const { $t } = useIntl();
  const lock = useLock();
  const { open } = useConfirmDialog();

  const onSend = useCallback(
    (command: CommandType) => {
      open(
        <FormattedMessage
          tagName="p"
          id={
            command === 'lock'
              ? 'DoorLock.ConfirmLock'
              : 'DoorLock.ConfirmUnlock'
          }
        />
      ).then(() => changeLock(command));
    },
    [open]
  );

  if (lock === null) {
    return null;
  }

  const locked = lock.lockStatus === 'LOCKED';
  const unlocked = lock.lockStatus === 'UNLOCKED';

  return (
    <Card>
      <CardTitle>
        <FormattedMessage id="DoorLock.Title" />
      </CardTitle>
      <div className={styles.row}>
        <FormattedMessage id="DoorLock.Status" tagName="div" />
        {locked && (
          <span className={styles.red}>
            <FormattedMessage id="DoorLock.Locked" />
          </span>
        )}
        {unlocked && (
          <span className={styles.green}>
            <FormattedMessage id="DoorLock.Unlocked" />
          </span>
        )}
      </div>
      {lock.athState != null && (
        <div className={styles.row}>
          <FormattedMessage id="DoorLock.ATS" tagName="div" />
          <FormattedMessage
            id={lock.athState > 0 ? 'On' : 'Off'}
            tagName="div"
          />
        </div>
      )}
      <div className={styles.btnContainer}>
        <button className={styles.btn} onClick={() => onSend('lock')}>
          <FormattedMessage id="DoorLock.Lock" />
        </button>
        <button className={styles.btn} onClick={() => onSend('unlock')}>
          <FormattedMessage id="DoorLock.Unlock" />
        </button>
      </div>
      {lock.lockState.commandState === 'FAILED' && (
        <div className={clsx(styles.row, styles.red, styles.state)}>
          <FormattedMessage
            id="DoorLock.ErrorReason"
            values={{
              reason: (lock.lockState?.errorMessage || 'UNKNOWN')
                .split(':')
                .map((msg) => $t({ id: `DoorLock.Reason.${msg}` }))
                .join(', '),
            }}
          />
        </div>
      )}
      {lock.lockState.commandState === 'SENT' && (
        <div className={clsx(styles.row, styles.blue, styles.state)}>
          <FormattedMessage id="DoorLock.InProgress" />
        </div>
      )}
      {lock.lockState.commandState === 'SUCCESS' && (
        <div className={clsx(styles.row, styles.green, styles.state)}>
          <FormattedMessage id="DoorLock.Success" />
        </div>
      )}
    </Card>
  );
};
